if (!customElements.get('rb-carousel')) {
  class RbCarousel extends HTMLElement {
    /** @type {HTMLElement | null} */
    #track;

    connectedCallback() {
      this.#track = this.querySelector('[data-track]');
      this.querySelector('[data-prev]')?.addEventListener('click', this.#prev);
      this.querySelector('[data-next]')?.addEventListener('click', this.#next);
    }

    disconnectedCallback() {
      this.querySelector('[data-prev]')?.removeEventListener('click', this.#prev);
      this.querySelector('[data-next]')?.removeEventListener('click', this.#next);
    }

    #prev = () => this.#move(-1);
    #next = () => this.#move(1);

    /**
     * @param {number} direction
     */
    #move(direction) {
      const track = this.#track;
      if (!track) return;
      const item = track.querySelector('.rb-carousel__item');
      const styles = getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '16') || 16;
      const width = item instanceof HTMLElement ? item.getBoundingClientRect().width : 220;
      track.scrollBy({ left: direction * (width + gap), behavior: 'smooth' });
    }
  }

  customElements.define('rb-carousel', RbCarousel);
}
